import React, { FunctionComponent } from 'react';
import Checkbox from '@liveramp/motif/core/Checkbox';
import { Edit } from '@liveramp/motif/icons';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { useDispatch } from 'react-redux';
import { archiveModalToggleView } from 'shared/store/features/archiveWorkOrdersModalSlice';
import { setSelectedWorkOrders } from 'shared/store/features/workOrdersTableSlice';
import { ArchiveStatus } from 'App/BillingDashboard/filterOptions.enum';
import styles from './styles.module.scss';
import useEditBarLogic from './useEditBarLogic';
import EditBarIconButton from './EditBarIconButton';

const EditBar: FunctionComponent = () => {
  const {
    setIsEditWorkOrderModalOpened,
    selectedWorkOrders,
    archiveFilterStatus,
    isLoading,
    onUnarchiveSubmit
  } = useEditBarLogic();
  const dispatch = useDispatch();

  return (
    <div className={styles.container}>
      <div className={styles.checkbox}>
        <Checkbox checked onClick={() => dispatch(setSelectedWorkOrders({ selectedWorkOrders: [] }))} />
      </div>
      <p>{`${selectedWorkOrders.length} work ${selectedWorkOrders.length > 1 ? 'orders' : 'order'} selected`}</p>
      <div className={styles.icons}>
        <EditBarIconButton
          dataTestId="edit-icon-button"
          icon={<Edit />}
          onClick={() => setIsEditWorkOrderModalOpened(true)}
          isDisabled={selectedWorkOrders.length > 1 || archiveFilterStatus === ArchiveStatus.archived}
          tooltipText={selectedWorkOrders.length > 1
            ? 'Only one work order can be edited at once'
            : (selectedWorkOrders.length === 1 && (selectedWorkOrders[0].isArchived) ? 'Archived work orders cannot be edited' : 'Edit work order')}
          isLoading={false}
        />
        {archiveFilterStatus === ArchiveStatus.active ? (
          <EditBarIconButton
            dataTestId="archive-icon-button"
            icon={<ArchiveIcon />}
            onClick={() => dispatch(archiveModalToggleView({ isArchiveWorkOrdersModalOpened: true }))}
            isDisabled={false}
            tooltipText="Archive work order"
            isLoading={isLoading}
          />
        ) : (
          <EditBarIconButton
            dataTestId="unarchive-icon-button"
            icon={<UnarchiveIcon />}
            onClick={onUnarchiveSubmit}
            isDisabled={false}
            tooltipText="Unarchive work order"
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
};

export default EditBar;
